var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5971 10.9256L19.9598 7.28824V3.08653C19.9598 2.3268 19.3442 1.7111 18.5833 1.7111C17.8242 1.7111 17.2086 2.3268 17.2086 3.08653V4.53705L14.5003 1.82868C13.1613 0.490412 10.8333 0.492786 9.49731 1.8311L0.402658 10.9256C-0.134219 11.4635 -0.134219 12.3339 0.402658 12.8711C0.939778 13.4088 1.8119 13.4088 2.34883 12.8711L11.4426 3.77635C11.7389 3.48166 12.261 3.48166 12.5557 3.77548L21.651 12.8711C21.9207 13.14 22.2723 13.2737 22.6239 13.2737C22.9761 13.2737 23.3283 13.1398 23.5972 12.8711C24.1343 12.334 24.1343 11.4636 23.5971 10.9256Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4773 6.38751C12.2131 6.12343 11.7852 6.12343 11.5218 6.38751L3.52212 14.3848C3.39582 14.5111 3.32422 14.6834 3.32422 14.8633V20.6963C3.32422 22.065 4.43402 23.1747 5.80271 23.1747H9.76336V17.041H14.2349V23.1747H18.1956C19.5642 23.1747 20.674 22.065 20.674 20.6963V14.8633C20.674 14.6834 20.603 14.5111 20.4761 14.3848L12.4773 6.38751Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.a99b34102509eb9c6221e2c44dc35ab3.svg";
export { ForwardRef as ReactComponent };